import React, { useRef, useEffect } from "react";
import ReactDOM from 'react-dom/client';
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from 'react-i18next';

const WideButton = () => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();

  const onClick = (e) => {
    e.preventDefault();
    dispatch({ type: 'TALK_TO_HUMAN' });
  }

  return (
    <div className="kil-chat-widget-wide-button">
      <a onClick={onClick} href="#">
        <span>{t('talk_to_human')}</span>
      </a>
    </div>
  );
}

export default WideButton;